import { render, staticRenderFns } from "./ShipperFeatures.vue?vue&type=template&id=29abdc1c"
import script from "./ShipperFeatures.vue?vue&type=script&lang=js"
export * from "./ShipperFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports